export default __webpack_public_path__ + "static/shape-future-5ac37904fd39eff6e53d0ea206341c83.webp";